export const AUDIO_PLAYBACK_SPEED_OPTIONS = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

/**
 * Keep playback-speed stepping consistent across the inline note player and
 * the floating reader mini-player.
 */
const getNextAudioPlaybackSpeed = (currentSpeed: number): number => {
    const currentIndex = AUDIO_PLAYBACK_SPEED_OPTIONS.findIndex(
        (speed) => speed === currentSpeed,
    );
    if (currentIndex < 0) {
        return 1;
    }

    return AUDIO_PLAYBACK_SPEED_OPTIONS[
        (currentIndex + 1) % AUDIO_PLAYBACK_SPEED_OPTIONS.length
    ];
};

export default getNextAudioPlaybackSpeed;
